export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "dismiss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dismiss"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error:"])}
      },
      "fr": {
        "dismiss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rejeter"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur:"])}
      }
    }
  })
}